import { ApiResponse } from './../../models/response-api';
import { environment } from './../../../../environment/environment';
import { Injectable } from '@angular/core';
import { CrudService } from '../crud-service/crud.service';
import { HttpClient } from '@angular/common/http';
import { Observable, map } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class OffreEsnService extends CrudService<ApiResponse<any>, number> {
  constructor(_http: HttpClient) {
    super(_http, `${environment.baseUrl}`);
  }

  /* get list offre besoin esn */

  getListoffrebesoinesn(data: {
    per_page?: number;
    page?: number;
    sort?: number;
    sortAttribute?: string;
  }) {
    let page = 1
    if(data?.page){
      page = data?.page + 1
    }
    return this._http.get<
      ApiResponse<any>
    >(`${this._base}/api/JobOffer/getJobOffersBesoinEsn?per_page=${data?.per_page}&page=${page}`);
  }

  /* get list candidature offre besoin esn */

  getListcandidaturebesoinesn(data: {
    company_id?: any;
    per_page?: number;
    page?: number;
    sort?: number;
    sortAttribute?: string;
  }) {
    let sort = '';
    if (data?.sort)
      sort = `&sort=${data.sort}&sortAttribute=${data.sortAttribute}`;
    return this._http.get<ApiResponse<any>>(
      `${this._base}/api/CompanyApply/getListCandidaturesByESNForJobOffer?company_id=${data?.company_id}&per_page=${data?.per_page}&page=${data?.page}${sort}`
    );
  }

  //retirer candidature
  retirercandidature(data: any) {
    return this._http.delete<ApiResponse<any>>(
      this._base +
        `/api/CompanyApply/deleteCandidatureFromJobOffer?company_id=${data.company_id}&job_offer_id=${data.job_offer_id}&user_id=${data.user_id}`,
      data
    );
  }

  ///getdetailoffrecandidature
  getoffrecandidatureById(
    company_apply_id: number
  ): Observable<ApiResponse<any>> {
    return this._http.get<ApiResponse<any>>(
      this._base +
        `/api/CompanyApply/getDetailsCandidatureJobOffer?company_apply_id=${company_apply_id}`
    );
  }
  ///////////////////////////////////////

  // search  candidature //////
  searchcandidature(data: any): Observable<ApiResponse<any>> {
    return this._http
      .post<ApiResponse<any>>(
        this._base + `/api/CompanyApply/searchInCandidaturesJobOffer`,
        data
      )
      .pipe(
        map((res: any) => {
          if (res) {
            return res;
          }
        })
      );
  }

  ///////////////////////
  // search  offre besoin esn //////
  searchoffrebesoinesn(data: any): Observable<ApiResponse<any>> {
    if (data?.page){ 
      data.page = data?.page +1
    } else{
      data.page = 1
    }
    if(data.search){
      let tabs = this.findDoubleQuotes(data.search);
      if (tabs.length <= 2) data.search = '"' + data.search + '"';
    }

    return this._http
      .post<ApiResponse<any>>(
        this._base + `/api/JobOffer/searchJobOfferBesoinEsn`,
        data
      )
      .pipe(
        map((res: any) => {
          if (res) {
            return res;
          }
        })
      );
  }


  freeSearchoffrebesoinesn(data: any): Observable<ApiResponse<any>> {

    if(data.search){
      let tabs = this.findDoubleQuotes(data.search);
      if (tabs.length <= 2) data.search = '"' + data.search + '"';
    }

    return this._http
      .post<ApiResponse<any>>(
        this._base + `/api/JobOffer/freeSearchJobOfferBesoinEsn`,
        data
      )
      .pipe(
        map((res: any) => {
          if (res) {
            return res;
          }
        })
      );
  }
/* get elment of header table call odder list */
getHeaderElements(id:number){
  return this._http.get<ApiResponse<any>>(this._base+`/api/UserPageActeur/getPagesWithSubPagesForUser?role_id=7&interface=7&id=${id}`);
}
changeDelectedElementHeader(data: any) {
  return this._http.post<ApiResponse<any>>(
    this._base +
      `/UserPageActeur/addRemoveSubPageToUser?role_id=7&interface=7`,
    data
  );
}
  /*get job offre  by id */
  getoffrebesoinesnById(id: number): Observable<ApiResponse<any>> {
    return this._http.get<ApiResponse<any>>(
      this._base + `/api/JobRequest/getById/${id}`
    );
  }

  /*archiver job offre */
  archiveroffrebesoinesn(jobOffer_id: string) {
    return this._http.post<ApiResponse<any>>(
      this._base +
        `/api/JobOffer/CompanyArchivedJobOffer?jobOffer_id=${jobOffer_id}`,
      {}
    );
  }

  /*archiver job offre */
  restaureroffrebesoinesn(jobOffer_id: number, company_id: number) {
    return this._http.post<ApiResponse<any>>(
      this._base +
        `/api/JobOffer/CompanyRestoredJobOffer?jobOffer_id=${jobOffer_id}&company_id=${company_id}`,
      {}
    );
  }

  // get list offre besoin esn archived
  getListoffrebesoinesnarchived(data: {
    per_page?: number;
    page?: number;
    sort?: number;
    sortAttribute?: string;
  }) {
    let page = 1
    if(data?.page){
      page = data?.page + 1
    }
    return this._http.get<ApiResponse<any>>(`${this._base}/api/JobOffer/getArchivedJobOffersBesoinEsn?per_page=${data?.per_page}&page=${page}`);
  }

  // search  offre besoin esn archived //////
  searchoffrebesoinesnarchived(data: any): Observable<ApiResponse<any>> {
    return this._http
      .post<ApiResponse<any>>(this._base + `/api/JobOffer/searchArchivedJobOffersBesoinEsn`,data)
  }

  freeSearchoffrebesoinesnarchived(data: any): Observable<ApiResponse<any>> {
    return this._http
      .post<ApiResponse<any>>(this._base + `/api/JobOffer/freeSearchArchivedJobOffersBesoinEsn`,data)
  }


  findDoubleQuotes(str: string): number[] {
    const indices: number[] = [];
    for (let i = 0; i < str.length; i++) {
      if (str[i] === '"') {
        indices.push(i);
      }
    }
    return indices;
  }

  /*contact responsable */
  contactjoboffer(body: any): Observable<ApiResponse<any>> {
    return this._http.post<ApiResponse<any>>(
      this._base + '/api/JobOffer/contactManagerJobOffer',
      body
    );
  }
}
